import { http } from '../rest';

export function resendVerificationEmail(http, demo) {
  return {
    async execute() {
      try {
        if (demo) {
          return;
        }
        await http.post('/resend_verification_email');
      } catch (error) {
        if (error && error.response && error.response.status === 404) return;
        throw error;
      }
    },
  };
}

export default resendVerificationEmail(http, process.env.DEMO);
